import { render, staticRenderFns } from "./SNMedicalWidget.vue?vue&type=template&id=4f692262&"
import script from "./SNMedicalWidget.vue?vue&type=script&lang=js&"
export * from "./SNMedicalWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../CommunityWebPortal/_app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f692262')) {
      api.createRecord('4f692262', component.options)
    } else {
      api.reload('4f692262', component.options)
    }
    module.hot.accept("./SNMedicalWidget.vue?vue&type=template&id=4f692262&", function () {
      api.rerender('4f692262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "VueCommon/common-components/src/components/Widgets/SNMedicalWidget.vue"
export default component.exports